(function () {

    'use strict';

    class EncasementSelectionDialogCtrl {
        constructor($mdDialog, paymentService, patient, entry, preloadedEncasements) {
            this.dialog = $mdDialog;
            this.paymentService = paymentService;
            this.patient = patient;
            this.entry = entry;

            this.loading = false;
            this.availableEncasements = preloadedEncasements || [];
            this.selectedEncasement = null;
        }

        static get $inject() {
            return ["$mdDialog", "paymentService", "patient", "entry", "preloadedEncasements"];
        }

        $onInit() {}

        confirmSelection() {
            if (this.selectedEncasement) {
                this.dialog.hide(this.selectedEncasement);
            } else {
                this.dialog.hide(null);
            }
        }

        continueWithoutEncasement() {
            this.dialog.hide(null);
        }

        isSelected(encasement) {
            return this.selectedEncasement &&
                   this.selectedEncasement.id === encasement.id;
        }

        cancel() {
            this.dialog.cancel();
        }
    }

    module.exports = {
        multiple: true,
        controllerAs: "vm",
        controller: EncasementSelectionDialogCtrl,
        bindToController: true,
        parent: $(document.body),
        clickOutsideToClose: true,
        template: require("./encasement-selection-dialog.tpl.html"),
    };

})();